// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2ZLz0aH7XbTQEVvtUnfUty","info-table":"_26fClyq0ub3ijG-N-i7I4O"};